import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivisionA',
  field: 'Number',
  weeks: [6, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'Multiples',
      questionTypes: ['aml2', 'amm', 'amn', 'amo', 'amp', 'amq'],
      archivedQuestionTypes: ['aml'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/1Multiples" */ './1MultiplesModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'CommonMultiples',
      questionTypes: ['amr', 'ams2', 'amt', 'amu2', 'amv', 'amw'],
      archivedQuestionTypes: ['ams', 'amu'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/2CommonMultiples" */ './2CommonMultiplesModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'Factors',
      questionTypes: ['amx', 'amy', 'amz', 'amA', 'amB', 'amC'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/3Factors" */ './3FactorsModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'CommonFactors',
      questionTypes: ['amD', 'amE', 'amF', 'amG', 'amH', 'amI'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/4CommonFactors" */ './4CommonFactorsModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'PrimeNumbers',
      questionTypes: ['amJ', 'amK', 'amL', 'amM', 'amN2', 'amO'],
      archivedQuestionTypes: ['amN'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/5PrimeNumbers" */ './5PrimeNumbersModels'
        )
    }),
    // Step 6
    newSmallStepContent({
      smallStep: 'SquareNumbers',
      questionTypes: ['amP2', 'amQ2', 'amR', 'amS2', 'amT', 'amU'],
      archivedQuestionTypes: ['amP', 'amQ', 'amS'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/6SquareNumbers" */ './6SquareNumbersModels'
        )
    }),
    // Step 7
    newSmallStepContent({
      smallStep: 'CubeNumbers',
      questionTypes: ['amV', 'amW', 'amX', 'amY2', 'amZ2', 'am0'],
      archivedQuestionTypes: ['amY', 'amZ'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/7CubeNumbers" */ './7CubeNumbersModels'
        )
    }),
    // Step 8
    newSmallStepContent({
      smallStep: 'MultiplyBy10100And1000',
      questionTypes: ['am1', 'am2', 'am3', 'am4', 'am52', 'am62'],
      archivedQuestionTypes: ['am5', 'am6'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/8MultiplyBy10100And1000" */ './8MultiplyBy10100And1000Models'
        )
    }),
    // Step 9
    newSmallStepContent({
      smallStep: 'DivideBy10100And1000',
      questionTypes: ['am7', 'am8', 'am9', 'ana', 'anb2', 'anc'],
      archivedQuestionTypes: ['anb'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/9DivideBy10100And1000" */ './9DivideBy10100And1000Models'
        )
    }),
    // Step 10
    newSmallStepContent({
      smallStep: 'MultiplesOf10100And1000',
      questionTypes: ['and', 'ane', 'anf2', 'ang', 'anh', 'ani'],
      archivedQuestionTypes: ['anf'],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/MultiplicationAndDivisionA/10MultiplesOf10100And1000" */ './10MultiplesOf10100And1000Models'
        )
    })
  ]
});
export default Block;
